export default __webpack_public_path__ + "static/media/identity.99ab0fa3.svg";